export default {
  // 泛育儿顾问信息
  userInfo: {
    worker: {},
    spuList: []
  },
  evaluatesList: [],
  servicesList: [],
  experienceList: []
}
